import "./App.css";
import { Provider } from "react-redux";
import store from "./components/Redux/Store";
import Routing from "./routing";
import { PopupWidget } from "react-calendly";
import { useEffect, useState } from "react";
import Preloader from "./preLoader";
import ReactGA from "react-ga4";

ReactGA.initialize("G-HGF4P4EC9N");

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  return (
    <>
      {isLoading ? (
        <Preloader name="Mohanraj's TechnoTales" />
      ) : (
        <Provider store={store}>
          <Routing />
          <div className="schedule">
            <PopupWidget
              url="https://calendly.com/mohanraj-mv-99/30min"
              rootElement={document.getElementById("root")}
              text="📅 Book a call!"
              textColor="#ffffff"
              color="#1d76bc"
            />
          </div>
        </Provider>
      )}
    </>
  );
}

export default App;
